import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { ArrowLeft, Mail, CheckCircle } from 'lucide-react';
import api from '../../lib/axios';
import { AuthShell } from './Login';

const schema = z.object({ email: z.string().email('Invalid email address') });

export default function ForgotPassword() {
  const [sent, setSent] = useState(false);

  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({
    resolver: zodResolver(schema),
  });

  async function onSubmit({ email }) {
    await api.post('/auth/forgot-password', { email });
    setSent(true);
  }

  return (
    <AuthShell title="Forgot password" subtitle="We'll send a reset link to your email">
      {sent ? (
        <div className="text-center py-6">
          <div className="w-14 h-14 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle size={28} className="text-emerald-600" />
          </div>
          <h3 className="font-semibold text-ink mb-2">Check your email</h3>
          <p className="text-sm text-ink-secondary mb-6">
            If an account exists for that address, you'll receive a reset link shortly.
          </p>
          <Link to="/login" className="btn-primary inline-flex">Back to login</Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <label className="label">Email address</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-muted" />
              <input
                {...register('email')}
                type="email"
                placeholder="you@example.com"
                className={`input pl-9 ${errors.email ? 'border-red-400' : ''}`}
              />
            </div>
            {errors.email && <p className="mt-1 text-xs text-red-500">{errors.email.message}</p>}
          </div>

          <button type="submit" disabled={isSubmitting} className="btn-primary w-full justify-center py-2.5">
            {isSubmitting ? 'Sending…' : 'Send reset link'}
          </button>

          <Link to="/login" className="flex items-center gap-1.5 justify-center text-sm text-ink-secondary hover:text-ink">
            <ArrowLeft size={14} /> Back to login
          </Link>
        </form>
      )}
    </AuthShell>
  );
}
